import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideAuth0 } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { providePREnvPicker } from '@bannerflow/ui';

// Conditionally provide Auth0 - skip for local and test environments
const authProviders =
    environment.stage === 'local' || environment.stage === 'test'
        ? []
        : [
              provideAuth0({
                  domain: environment.LOGIN_URL,
                  clientId: environment.CLIENT_ID,
                  authorizationParams: {
                      redirect_uri: `${window.location.origin}/${window.location.search}`,
                      audience: 'https://bannerflow.com/resources/',
                      scope: 'openid profile email offline_access'
                  },
                  httpInterceptor: {
                      allowedList: environment.API_URLS.map(url => `${url}/*`)
                  },
                  useRefreshTokens: true
              })
          ];

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        ...authProviders,
        provideHttpClient(withInterceptorsFromDi()), // HttpClient
        provideAnimationsAsync(), // Needed for @bannerflow/ui
        environment.stage === 'sandbox'
            ? providePREnvPicker({
                  feRepos: [
                      {
                          repoName: 'frontend-template'
                      }
                  ],
                  beRepos: [
                      {
                          repoName: 'backend-template-service',
                          path: ''
                      }
                  ]
              })
            : []
    ]
};
